import React, { Dispatch, SetStateAction } from 'react';
import { StyleSheet, Text } from 'react-native';
import Moment from 'moment';
import { getRangeBackground, getRangeBorder, getRangeTextColor } from '../Utils';
import { DateSelectionRange } from '../../../redux/dateRangeSlice';
import PressableStyled from '../../PressableStyled';
import Colors from '../../../constants/Colors';
import isMobile from '../../IsMobile';
import { logEvent } from '../../LogEvent';

interface RangeButtonProps {
  comparing: boolean,
  compareToggled: boolean,
  index: DateSelectionRange,
  selectedRangeIndex: DateSelectionRange,
  setSelectedRangeIndex: Dispatch<SetStateAction<DateSelectionRange>>,
  setStartDateToApply: Dispatch<SetStateAction<string>>,
  setEndDateToApply: Dispatch<SetStateAction<string>>,
  setCompareStartDateToApply: Dispatch<SetStateAction<string>>,
  setCompareEndDateToApply: Dispatch<SetStateAction<string>>,
  title: string,
}

const testIDs: string[] = [
  'date-range-day-btn',
  'date-range-last-week-btn',
  'date-range-last-month-btn',
  'date-range-last-three-months-btn',
  'date-range-last-six-months-btn',
  'date-range-last-year-btn',
  'date-range-custom-btn',
  'date-range-live-btn',
];

const RangeButton = ({
  comparing, compareToggled, index, setSelectedRangeIndex, setStartDateToApply, setEndDateToApply,
  setCompareStartDateToApply, setCompareEndDateToApply, selectedRangeIndex, title,
}: RangeButtonProps) => {
  const selected: boolean = selectedRangeIndex === index;
  let subtractType: 'days' | 'months' | 'year' | 'minutes' = 'days';
  let subtractCount: number = index === 0 ? 0 : 1;
  if (index === 1) subtractCount = 7;
  else if (index === 2) subtractType = 'months';
  else if (index === 3) {
    subtractType = 'months';
    subtractCount = 3;
  } else if (index === 4) {
    subtractType = 'months';
    subtractCount = 6;
  } else if (index === 5) subtractType = 'year';
  else if (index === 7) subtractType = 'minutes';

  return <PressableStyled
    style={[
      isMobile ? styles.mobileButton : styles.desktopButton,
      {
        backgroundColor: getRangeBackground(selected, comparing),
        borderColor: getRangeBorder(selected, comparing),
      },
    ]}
    onPress={() => {
      if (!selected) {
        setSelectedRangeIndex(index);
        const startDate: string = Moment().subtract(subtractCount, subtractType)
          .startOf('day').toDate()
          .toISOString();
        const endDate: string = Moment().toISOString();
        if (compareToggled) {
          setCompareStartDateToApply(startDate);
          setCompareEndDateToApply(endDate);
        }
        setStartDateToApply(startDate);
        setEndDateToApply(endDate);
      }
      logEvent('DateComponent', 'LIVE');
    }}
    testID={testIDs[index]}
  >
    <Text style={[
      isMobile ? styles.mobileText : styles.desktopText,
      { color: getRangeTextColor(selected, comparing) },
    ]}>
      {title}
    </Text>
  </PressableStyled>;
};

const styles = StyleSheet.create({
  desktopButton: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue300,
    marginVertical: 4,
    paddingVertical: 4,
    paddingHorizontal: 12,
    width: 124,
  },
  mobileButton: {
    minWidth: 32,
    paddingHorizontal: 8,
    height: 32,
    borderRadius: 8,
    marginHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: isMobile ? 4 : undefined,
  },
  desktopText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
  },
  mobileText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_400Regular',
  },
});

export default RangeButton;
